<template>
  <div>
    <el-form
      :inline="true"
      ref="formRef"
      :rules="rules"
      label-width="100px"
      :model="ruleForm"
      class="demo-form-inline"
      :disabled="formStatus === 3"
    >
      <el-row>
        <el-col :span="24">
          <el-form-item label="任务名称" prop="dutyName">
            <el-input
              v-model="ruleForm.dutyName"
              placeholder="任务名称"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24" v-if="taskStatus === '巡防任务'">
          <el-form-item label="巡防路线" prop="">
            <el-select
              v-model="ruleForm.patrolmanId"
              placeholder="请选择"
              style="width: 100%"
            >
              <el-option
                v-for="item in patrolList"
                :key="item.patrolmanId"
                :label="item.patrolmanName"
                :value="item.patrolmanId"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="任务类型" prop="dutyType">
            <!-- zaxf_task_type -->
            <template v-if="taskStatus === '社区任务'">
              <el-select
                v-model="ruleForm.dutyType"
                placeholder="任务类型"
                style="width: 100%"
              >
                <el-option
                  v-for="item in [
                    { name: '走访关怀', value: '1' },
                    { name: '去电关怀', value: '2' },
                  ]"
                  :key="item.name"
                  :label="item.name"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </template>
            <template v-else>
              <h-selectcode
                type="zaxf_task_type"
                v-model="ruleForm.dutyType"
                placeholder="任务类型"
              ></h-selectcode>
            </template>
          </el-form-item>
        </el-col>
        <el-col :span="24" v-if="taskStatus === '巡防任务'">
          <el-form-item label="任务描述" prop="taskDescribe">
            <el-input
              v-model="ruleForm.taskDescribe"
              type="textarea"
              :autosize="{ minRows: 3, maxRows: 5 }"
              maxlength="150"
              show-word-limit
              placeholder="任务名称"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item
            label="频次"
            :prop="
              ruleForm.dutyTimesType === 'Week' ? 'dutyTimesValue' : 'dutyTime'
            "
          >
            <el-radio-group v-model="ruleForm.dutyTimes">
              <el-radio label="1">单次</el-radio>
              <el-radio label="2">多次</el-radio>
            </el-radio-group>
            <div class="radio-dc" v-if="ruleForm.dutyTimes === '2'">
              <div>
                <el-radio
                  v-model="ruleForm.dutyTimesType"
                  label="Month"
                  size="large"
                >
                  每月
                </el-radio>
                <el-radio
                  v-model="ruleForm.dutyTimesType"
                  label="Week"
                  size="large"
                >
                  每周
                </el-radio>
                <el-radio
                  v-model="ruleForm.dutyTimesType"
                  label="Year"
                  size="large"
                >
                  每年
                </el-radio>
              </div>

              <div v-if="ruleForm.dutyTimesType === 'Week'">
                <el-checkbox-group v-model="ruleForm.dutyTimesValue">
                  <el-checkbox label="1">周一</el-checkbox>
                  <el-checkbox label="2">周二</el-checkbox>
                  <el-checkbox label="3">周三</el-checkbox>
                  <el-checkbox label="4">周四</el-checkbox>
                  <el-checkbox label="5">周五</el-checkbox>
                  <el-checkbox label="6">周六</el-checkbox>
                  <el-checkbox label="7">周日</el-checkbox>
                </el-checkbox-group>
              </div>
              <div
                v-if="ruleForm.dutyTimesType === 'Month'"
                class="selectMonth"
              >
                <el-date-picker
                  v-if="ruleForm.dutyTimesType === 'Month'"
                  popper-class="picker-data"
                  style="width: 100%"
                  v-model="ruleForm.dutyTime"
                  format="DD"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始天"
                  end-placeholder="结束天"
                  :disabled-date="pickerOptions"
                />
              </div>
              <div v-if="ruleForm.dutyTimesType === 'Year'" class="selectMonth">
                <el-date-picker
                  v-if="ruleForm.dutyTimesType === 'Year'"
                  popper-class="picker-data"
                  style="width: 100%"
                  format="MM"
                  v-model="ruleForm.dutyTime"
                  type="monthrange"
                  range-separator="至"
                  start-placeholder="开始月份"
                  end-placeholder="结束月份"
                />
              </div>
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="任务时间" prop="search">
            <el-date-picker
              v-model="ruleForm.search"
              type="datetimerange"
              range-separator="至"
              start-placeholder="请选择开始日期"
              end-placeholder="请选择结束日期"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="24" v-if="taskStatus === '社区任务'">
          <el-form-item label="人员范围" prop="careId">
            <el-select
              v-model="ruleForm.careId"
              placeholder="人员范围"
              style="width: 100%"
            >
              <el-option
                v-for="item in optionsJsList"
                :key="item.careId"
                :label="item.careLibraryName"
                :value="item.careId"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="负责人" prop="userId">
            <el-select
              v-model="ruleForm.userId"
              placeholder="负责人"
              style="width: 100%"
            >
              <el-option
                v-for="item in optionsYhList"
                :key="item.userId"
                :label="item.name + '  _  ' + item.username"
                :value="item.userId"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="24" v-if="formStatus == 1">
          <el-form-item label="区域选择" prop="regionId">
            <el-button
              style="width: 100%; margin: 0 6px"
              @click="handleRegion()"
              >{{
                regionObj ? `已选择：${regionObj.name}` : "请选择区域"
              }}</el-button
            >
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div class="form-button">
      <el-button
        v-if="formStatus !== 3"
        type="primary"
        @click="onSubmit(formRef)"
        >提交</el-button
      >
      <el-button @click="cancel">返回</el-button>
    </div>
    <el-dialog
      v-model="formVisible"
      title="区域选择"
      width="33%"
      @close="close"
    >
      <regionDetial
        v-if="formVisible"
        @submit="regionSubmit"
        @cancel="close"
      ></regionDetial>
    </el-dialog>
  </div>
</template>
<script>
import {
  defineComponent,
  reactive,
  toRefs,
  ref,
  watchEffect,
  computed,
} from "vue";
import {
  saveOrUpdateInfo,
  peoplelist,
} from "@/api/communityCare/communityCareApi.js";
import { taskSave, personnelInfo } from "@/api/prevention/prevention.js";
import { userList } from "@/api/system/patrol";
import { queryUserList } from "@/api/user.js";
import { formatDateHMS } from "@/utils/index.js";
import util from "@util/js";
import { ElMessage } from "element-plus";
// import { ElMessageBox, ElMessage } from "element-plus";
// import _ from "lodash";
export default defineComponent({
  props: {
    taskStatus: {
      type: String,
      default: "社区任务", // 分社区任务 和  巡防任务
    },
    formStatus: {
      type: Number,
      default: 1,
    },
    userFormData: {
      type: Object,
      default: () => {},
    },
  },
  setup(props, context) {
    const state = reactive({
      ruleForm: {
        dutyTimes: "1",
        dutyTimesType: "Week",
        dutyName: "",
        patrolmanId: "",
        dutyType: "",
        dutyTimesValue: [],
        careId: "",
        userId: "",
        dutyTime: "",
        taskDescribe: "",
        regionId: "",
        search: "",
      },
      rules: {
        dutyName: [
          {
            required: true,
            message: "请输入任务名称",
            trigger: "blur",
          },
        ],
        dutyType: [
          {
            required: true,
            message: "请选择任务类型",
            trigger: "blur",
          },
        ],
        dutyTime: [
          {
            required: true,
            message: "请选择任务频次",
            trigger: "blur",
          },
        ],
        dutyTimesValue: [
          {
            required: true,
            message: "请选择任务频次",
            trigger: "blur",
          },
        ],
        careId: [
          {
            required: true,
            message: "请选择关怀人员",
            trigger: "blur",
          },
        ],
        regionId: [
          {
            required: true,
            message: "请选择区域",
          },
        ],
        search: [
          {
            required: true,
            message: "请选择时间",
            trigger: "blur",
          },
        ],
      },
      optionsJsList: [],
      optionsYhList: [],
      formVisible: false,
      regionObj: null,
      patrolList: [],
    });
    const formRef = ref(null);
    watchEffect(() => {
      if (state.ruleForm.dutyTimesType) {
        state.ruleForm.dutyTime = "";
      }
    });
    watchEffect(() => {
      if (props.formStatus == 2) {
        state.ruleForm = { ...state.ruleForm, ...props.userFormData };
        if (props.userFormData.startTime) {
          state.ruleForm.search = [
            props.userFormData.startTime,
            props.userFormData.endTime,
          ];
        }
        if (props.userFormData.dutyTimesValue) {
          state.ruleForm.dutyTimesValue =
            props.userFormData.dutyTimesValue.split("-");
        } else {
          state.ruleForm.dutyTimesValue = [];
          state.ruleForm.dutyTimesType = "Week";
        }
      } else if (props.formStatus == 1) {
        state.ruleForm = {
          dutyTimes: "1",
          dutyTimesType: "Week",
          dutyName: "",
          dutyType: "",
          dutyTimesValue: [],
          careId: "",
          userId: "",
        };
        // formRef.value && formRef.value.resetFields();
        state.ruleForm.search = [];
      } else if (props.formStatus == 3) {
        if (props.taskStatus === "社区任务") {
          state.ruleForm = { ...state.ruleForm, ...props.userFormData };
          if (props.userFormData.startTime) {
            state.ruleForm.search = [
              props.userFormData.startTime,
              props.userFormData.endTime,
            ];
          }
          if (props.userFormData.dutyTimesValue) {
            state.ruleForm.dutyTimesValue =
              props.userFormData.dutyTimesValue.split("-");
          } else {
            state.ruleForm.dutyTimesValue = [];
            state.ruleForm.dutyTimesType = "Week";
          }
        } else {
          state.ruleForm.dutyName = props.userFormData.taskName;
          state.ruleForm.dutyType = props.userFormData.taskType;
          state.ruleForm.userId = props.userFormData.taskResponsibilityId;
          state.ruleForm.taskDescribe = props.userFormData.taskDescribe;
          state.ruleForm.dutyTimes = props.userFormData.taskFrequency;
          if (props.userFormData.taskStartTimeDict) {
            state.ruleForm.search = [
              props.userFormData.taskStartTimeDict,
              props.userFormData.taskEndTimeDict,
            ];
          }
          if (
            props.userFormData.dutyTimesValue ||
            props.userFormData.taskTimesValue
          ) {
            state.ruleForm.dutyTimesType = props.userFormData.taskTimesType;
            state.ruleForm.dutyTimesValue =
              props.taskStatus == "社区任务"
                ? props.userFormData.dutyTimesValue.split("-")
                : props.userFormData.taskTimesValue.split("-");
            const num1 =
              state.ruleForm.dutyTimesType == "Year"
                ? new Date().setMonth(
                    parseInt(state.ruleForm.dutyTimesValue[0]) - 1
                  )
                : new Date().setDate(state.ruleForm.dutyTimesValue[0]);
            const num2 =
              state.ruleForm.dutyTimesType == "Year"
                ? new Date().setMonth(
                    parseInt(state.ruleForm.dutyTimesValue[1]) - 1
                  )
                : new Date().setDate(state.ruleForm.dutyTimesValue[0]);
            console.log(new Date(num1), num2);
            state.ruleForm.dutyTime = [new Date(num1), new Date(num2)];
          } else {
            state.ruleForm.dutyTimesValue = [];
            state.ruleForm.dutyTimesType = "Week";
          }
        }
      }
    });

    watchEffect(() => {
      if (state.regionObj) {
        state.ruleForm.regionId = state.regionObj.id;
      }
    });
    // 此监听为了选择频次时验证表单用
    watchEffect(() => {
      if (state.ruleForm.dutyTimes === "1") {
        state.ruleForm.dutyTime = [1, 6];
        state.ruleForm.dutyTimesValue = "5";
        console.log(state.ruleForm.dutyTime);
      } else {
        state.ruleForm.dutyTime = "";
        state.ruleForm.dutyTimesValue = [];
      }
    });
    const pickerOptions = (time) => {
      const year = new Date().getFullYear();
      const month = new Date().getMonth() + 1;
      const firstTime = new Date(year, month - 1, 1);
      const lastTime = new Date(year, month, 0);
      return (
        time.getTime() < new Date(firstTime) ||
        time.getTime() > new Date(lastTime)
      ); // 选择本天到月底的日期
    };
    // const pickerYear = (time) => {
    //   return time.getTime() < Date.now() - 8.64e7;
    // };
    const timeProps = computed(() => {});

    const onSubmit = async (formEl) => {
      if (!formEl) return;
      formEl.validate(async (valid) => {
        if (valid) {
          if (state.ruleForm.search) {
            state.ruleForm.startTime = formatDateHMS(state.ruleForm.search[0]);
            state.ruleForm.endTime = formatDateHMS(state.ruleForm.search[1]);
          } else {
            state.ruleForm.startTime = "";
            state.ruleForm.endTime = "";
          }
          const from = JSON.parse(JSON.stringify(state.ruleForm));
          for (const key in from) {
            if (!from[key]) {
              delete from[key];
            }
          }
          if (state.ruleForm.dutyTimes === "1") {
            delete from.dutyTimesType;
            delete from.dutyTimesValue;
          } else {
            if (state.ruleForm.dutyTimesType === "Year") {
              // delete from.dutyTimesValue;
              from.dutyTimesValue = `${
                new Date(from.dutyTime[0]).getMonth() + 1
              }-${new Date(from.dutyTime[1]).getMonth() + 1}`;
            } else if (state.ruleForm.dutyTimesType === "Week") {
              from.dutyTimesValue = from.dutyTimesValue.join("-");
            } else if (state.ruleForm.dutyTimesType === "Month") {
              from.dutyTimesValue = `${new Date(
                from.dutyTime[0]
              ).getDate()}-${new Date(from.dutyTime[1]).getDate()}`;
            }
          }
          let res;
          if (props.taskStatus === "社区任务") {
            res = await saveOrUpdateInfo(from);
          } else if (props.taskStatus === "巡防任务") {
            const param = {
              regionId: from.regionId,
              taskDescribe: from.taskDescribe,
              taskEndTime: formatDateHMS(state.ruleForm.search[1]),
              taskStartTime: formatDateHMS(state.ruleForm.search[0]),
              taskName: from.dutyName,
              taskResponsibilityId: from.userId, // 责任人
              taskTimesType: from.dutyTimes == "2" ? from.dutyTimesType : "", // 任务多次类型
              taskTimesValue: from.dutyTimes == "2" ? from.dutyTimesValue : "", // 任务多次类型
              taskType: from.dutyType, // 任务多次类型
              taskFrequency: from.dutyTimes, // 任务多次类型
              patrolmanId: from.patrolmanId, // 任务多次类型
            };
            util.formatForm(param);
            // console.log(param);
            // if (!param.taskTimesValue) {
            //   ElMessage({
            //     type: "warning",
            //     message: "请选择频次",
            //   });
            //   return;
            // }
            res = await taskSave(param);
          }
          if (res.code === 0) {
            ElMessage({
              type: "success",
              message: props.formStatus === 1 ? "添加成功" : "修改成功",
            });
            context.emit("submit");
          }
        } else {
          return false;
        }
      });
    };
    const selectZd = async () => {
      if (props.taskStatus === "社区任务") {
        const paramss = {
          limit: 20,
          page: 1,
        };
        const res = await peoplelist(paramss);
        state.optionsJsList = res.page.list;
        const params = {
          limit: 200000,
          page: 1,
          hasSonDept: true,
          deptId: 0,
        };
        const ress = await queryUserList(params);
        state.optionsYhList = ress.page.list;
      } else if (props.taskStatus === "巡防任务") {
        const params = {
          isPage: false,
        };
        const res = await personnelInfo(params);
        res.page.list.forEach((element) => {
          element.userId = element.id;
          element.username = element.occupationDict;
        });
        state.optionsYhList = res.page.list;
      }
    };
    selectZd();
    const cancel = () => {
      context.emit("cancel");
      state.regionObj = null;
      state.ruleForm.regionId = "";
    };
    const handleRegion = () => {
      state.formVisible = true;
    };
    const close = () => {
      state.formVisible = false;
    };
    const regionSubmit = (value) => {
      if (value.length > 0) {
        state.regionObj = value[0];
      }
    };
    //巡防路径
    const getPatrolList = async () => {
      const parms = {
        isPage: false,
      };
      const res = await userList(parms);
      if (res.code == 0) {
        state.patrolList = res.page.list;
        console.log(state.patrolList, 55555555);
      }
    };
    getPatrolList();
    return {
      ...toRefs(state),
      cancel,
      onSubmit,
      formRef,
      handleRegion,
      regionSubmit,
      close,
      pickerOptions,
      timeProps,
      // pickerYear,
    };
  },
});
</script>
<style lang="scss" scoped>
.radio-dc {
  width: 100%;
}
.form-button {
  width: 100%;
  display: flex;
  justify-content: center;
  // margin-left: 50px;
}
.el-form-item {
  width: 80%;
  .selectMonth {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-around;
  }
  div {
    margin: 0 6px;
  }
}
</style>
<style lang="scss">
.picker-data {
  left: 631px;
  .el-date-range-picker__header {
    display: none;
  }
  .el-picker-panel__content.el-date-range-picker__content.is-right {
    display: none;
  }
  .el-date-range-picker__content {
    width: 100%;
  }
}
</style>
